import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../components/Button'
import { GO_DE_GQL_BACKEND_URL, Routes } from '../../../constants'
import { useAuth } from '../../../contexts/AuthContext'
import { FeaturedProps } from '../../../types/featured'
import RewardCard from '../../../components/RewardCard';
import { FetchApi } from '../../../api/fetch'


function Rewards() {
   const { setIsLoadingOverlayDisplay } = useAuth()
   const [, setFeatured] = useState<FeaturedProps[]>([])
   useEffect(() => {
      // getFeatured()
   }, [])



   const getFeatured = async () => {
      setIsLoadingOverlayDisplay(true)

      try {
         const feat = await FetchApi({
            endpoint: GO_DE_GQL_BACKEND_URL,
            method: "POST",
            body:  ({
               query: `{
                  featuredProject {
                     nodes {
                        description
                        id
                        name
                        position
                        projectUrl
                        thumbnailUrl
                      }
                   }
               }`,
               variables: {}
            })
         })
         const sorted = feat?.data?.featuredProject?.nodes?.sort((a: FeaturedProps, b: FeaturedProps) => a.position - b.position)
         setFeatured(sorted)
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }




   return (
      <div className='w-11/12 m-auto my-6'>
         <div className="mt-0 mb-10 flex flex-row justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-3xl text-left">
               Rewards (Giveaways)
            </h1>
            <div className="w-full sm:w-auto flex items-center space-x-4">
               <Link to={Routes.ALL_COURSES}>
                  <Button
                     type="button"
                     className="mb-0 sm:mb-2 w-auto btn bg-gradient text-kyzzen-primary text-sm font-medium flex items-center"
                  >
                     Create New
                  </Button>
               </Link>

            </div>
         </div>

         <RewardCard key={1} data={{}} getFeatured={getFeatured} />
         <RewardCard key={1} data={{}} getFeatured={getFeatured} />
         <RewardCard key={1} data={{}} getFeatured={getFeatured} />
         <RewardCard key={1} data={{}} getFeatured={getFeatured} />

      </div >
   )
}

export default Rewards